import { formatToTimeZone } from "date-fns-timezone";
import isValid from "date-fns/is_valid";
import parse from "date-fns/parse";

type Precision = keyof typeof formats;

const noDate = "-";

const formats = {
    UNKNOWN_DATE_PRECISION: "YYYY-MM-DD",
    SECOND: "YYYY-MM-DD - HH:mm:ss",
    MINUTE: "YYYY-MM-DD - hh:mm a",
    DAY: "YYYY-MM-DD",
    MONTH: "YYYY-MM",
    YEAR: "YYYY",
};

export const formatDatetimeString = ({
    str,
    precision = "DAY",
}: {
    str: string | void;
    precision?: Precision;
}) => {
    if (!str) return noDate;

    const dateObj = parse(str);
    if (!isValid(dateObj)) return noDate;

    const format = formats[precision];
    const date = formatToTimeZone(dateObj, format, {
        timeZone: "Etc/UTC",
    });

    if (format === formats.YEAR) return `${date}-##-##`;
    if (format === formats.MONTH) return `${date}-##`;
    return date;
};
